export default function CandidateNoTest() {
    return (
        <div className="max-w-lg mx-auto p-6 text-center">
            <h1 className="text-2xl font-bold text-gray-700 mb-4">No Test Assigned</h1>
            <p className="text-gray-600">
                Your account is valid, but no test has been assigned to you yet.
                Please contact your administrator for assistance.
            </p>
        </div>
    );
}
